import styled, { keyframes } from 'styled-components';
import { Colors } from 'enums';

const spinner = keyframes` 0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 10px solid ${Colors.gray4};
  border-top: 10px solid ${Colors.yellow1};
  border-radius: 50%;
  animation: ${spinner} 1.5s linear infinite;
`;
